import React from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Reveal from '../components/Reveal';

// Sample blog post data - in a real app, this would come from an API or CMS
const BLOG_POSTS = {
};

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = BLOG_POSTS[slug];

  if (!post) {
    return (
      <div className="blog-page">
        <div className="section-inner" style={{ padding: '4rem 1rem', textAlign: 'center' }}>
          <h1>Post Not Found</h1>
          <p>The blog post you're looking for doesn't exist.</p>
          <Link to="/blog" className="btn-primary" style={{ marginTop: '1.5rem', display: 'inline-block' }}>
            Back to News
          </Link>
        </div>
      </div>
    );
  }

  const BLOG_POST_SCHEMA = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BlogPosting',
        '@id': `https://phennx.io/blog/${post.slug}#blogpost`,
        headline: post.title,
        description: post.content.replace(/<[^>]*>/g, '').substring(0, 160),
        image: `https://phennx.io${post.image}`,
        datePublished: post.date,
        author: {
          '@type': 'Person',
          name: post.author,
          jobTitle: post.authorRole,
        },
        publisher: {
          '@type': 'Organization',
          name: 'Phennx',
          logo: {
            '@type': 'ImageObject',
            url: 'https://phennx.io/logo-full-transparent.png',
          },
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title={`${post.title} - Phennx News`}
        description={post.content.replace(/<[^>]*>/g, '').substring(0, 160)}
        path={`/blog/${post.slug}`}
        image={post.image}
        type="article"
        schema={BLOG_POST_SCHEMA}
      />
      <article className="blog-post-page" aria-label={post.title}>
        <header className="blog-post-page__hero">
          <div className="section-inner">
            <Link to="/blog" className="blog-post-page__back">
              <i className="pi pi-arrow-left" style={{ marginRight: '0.5rem' }} />
              Back to News
            </Link>
            <div className="blog-post-page__category">{post.category}</div>
            <h1 className="blog-post-page__title">{post.title}</h1>
            <div className="blog-post-page__meta">
              <div className="blog-post-page__author-info">
                <span className="blog-post-page__author">{post.author}</span>
                {post.authorRole && (
                  <span className="blog-post-page__author-role">{post.authorRole}</span>
                )}
              </div>
              <div className="blog-post-page__date-info">
                <time dateTime={post.date}>
                  {new Date(post.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </time>
                <span className="blog-post-page__read-time">{post.readTime}</span>
              </div>
            </div>
          </div>
        </header>

        {post.image && (
          <div className="blog-post-page__featured-image">
            <img src={post.image} alt={post.title} loading="eager" />
          </div>
        )}

        <section className="blog-post-page__content">
          <div className="section-inner">
            <Reveal>
              <div
                className="blog-post-page__body"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />
            </Reveal>
          </div>
        </section>
      </article>
    </>
  );
}

